import { hasSchemaType } from "./schemaFormModel";

const schemaProperties = schema => schema?.properties ?? {};

const isSummaryProperty = schema => !hasSchemaType(schema, "array")
	&& !hasSchemaType(schema, "object");

export function getArrayTableColumns(arraySchema) {
	const itemSchema = arraySchema?.items;
	const properties = schemaProperties(itemSchema);
	const configuredKeys = arraySchema?.metadata?.summary;
	const propertyEntries = Array.isArray(configuredKeys)
		? configuredKeys
			.filter(key => Object.prototype.hasOwnProperty.call(properties, key))
			.map(key => [key, properties[key]])
		: Object.entries(properties).filter(([, propertySchema]) => isSummaryProperty(propertySchema));
	const required = new Set(itemSchema?.required ?? []);
	const columns = propertyEntries.map(([key, propertySchema]) => ({
		key,
		title: propertySchema.title || key,
		required: required.has(key),
		schema: propertySchema
	}));

	return columns.length > 0
		? columns
		: [{
			key: "$index",
			title: "Entry",
			required: false,
			isIndex: true
		}];
}

export function formatArrayTableValue(value, schema) {
	if(value === undefined || value === null || value === "") {
		return "--";
	}

	if(Array.isArray(schema?.enum) && Array.isArray(schema?.enumNames)) {
		const index = schema.enum.indexOf(value);
		if(index >= 0 && schema.enumNames[index] !== undefined) {
			return schema.enumNames[index];
		}
	}

	if(typeof value === "boolean") {
		return value ? "Yes" : "No";
	}

	if(Array.isArray(value)) {
		return value.length > 0 ? value.join(", ") : "--";
	}

	if(typeof value === "object") {
		return "Details";
	}

	return value;
}

export function formatArrayTableCell(item, column, index) {
	return column.isIndex
		? `Entry ${index + 1}`
		: formatArrayTableValue(item?.[column.key], column.schema);
}
